<template>
  <div class="min-h-screen bg-surface-50 dark:bg-surface-950 transition-colors duration-300">
    <!-- Subtle background pattern -->
    <div class="fixed inset-0 bg-pattern-dots pointer-events-none opacity-40 dark:opacity-100 z-0"></div>
    <!-- Mesh gradient overlay -->
    <div class="fixed inset-0 bg-mesh-gradient dark:bg-mesh-gradient-dark pointer-events-none z-0"></div>

    <!-- App content -->
    <div class="relative z-10">
      <router-view />
    </div>

    <ToastContainer />
  </div>
</template>

<script setup>
import { onMounted } from 'vue'
import ToastContainer from '@/components/ui/ToastContainer.vue'
import { useDarkMode } from '@/composables/useDarkMode'

const { initTheme } = useDarkMode()

onMounted(() => {
  const savedTheme = localStorage.getItem('theme')
  if (savedTheme) {
    document.documentElement.classList.toggle('dark', savedTheme === 'dark')
  } else if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
    document.documentElement.classList.add('dark')
  }
})
</script>
